import { Link, NavLink } from "react-router-dom";
import { Zap, Phone, MessageSquare, UserCircle2, LogIn } from "lucide-react";
import { BUSINESS_PHONE, BUSINESS_PHONE_FORMATTED, BRAND } from "@/lib/constants";
import { useT } from "@/lib/i18n";
import { useVisitorAuth } from "@/context/VisitorAuthContext";
import LangToggle from "@/components/LangToggle";

export default function Navbar() {
    const { t } = useT();
    const { visitor } = useVisitorAuth();
    const navItems = [
        { to: "/homeowners", label: t("nav_homeowners") },
        { to: "/renters", label: t("nav_renters") },
        { to: "/moving", label: t("nav_moving") },
        { to: "/business", label: t("nav_business") },
        { to: "/compare-texas", label: t("nav_texas") },
    ];
    return (
        <header className="sticky top-0 z-40 glass" data-testid="site-navbar">
            <div className="max-w-7xl mx-auto px-3 sm:px-6 py-3 flex items-center gap-3">
                <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="brand-logo-link">
                    <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-emerald-500/20 border border-emerald-500/40 shrink-0">
                        <Zap className="w-5 h-5 text-emerald-300" />
                    </span>
                    <span className="font-extrabold tracking-tight text-white text-base sm:text-lg whitespace-nowrap">
                        {BRAND}
                    </span>
                </Link>
                <nav className="hidden md:flex items-center gap-1 ml-6">
                    {navItems.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            data-testid={`nav-${n.to.replace("/", "")}`}
                            className={({ isActive }) =>
                                `px-3 py-2 rounded-full text-sm font-medium transition ${
                                    isActive
                                        ? "bg-white/10 text-white"
                                        : "text-slate-300 hover:text-white hover:bg-white/5"
                                }`
                            }
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="ml-auto flex items-center gap-2 shrink-0">
                    <LangToggle compact />
                    {visitor ? (
                        <Link
                            to="/my-account"
                            data-testid="nav-my-account-link"
                            className="btn-ghost !py-2 !min-h-0 text-xs sm:text-sm !px-3"
                        >
                            <UserCircle2 className="w-4 h-4" /> <span className="hidden sm:inline">My account</span>
                        </Link>
                    ) : (
                        <Link
                            to="/sign-in"
                            data-testid="nav-signin-link"
                            className="btn-ghost !py-2 !min-h-0 text-xs sm:text-sm !px-3"
                        >
                            <LogIn className="w-4 h-4" /> <span className="hidden sm:inline">Sign in</span>
                        </Link>
                    )}
                    <div className="hidden md:block">
                        <a
                            href={`tel:${BUSINESS_PHONE}`}
                            data-testid="nav-call-cta"
                            className="btn-ghost !py-2 !min-h-0 text-sm"
                        >
                            <Phone className="w-4 h-4" /> {BUSINESS_PHONE_FORMATTED}
                        </a>
                    </div>
                    <a
                        href={`sms:${BUSINESS_PHONE}?&body=Hi, I'd like help comparing electricity options.`}
                        data-testid="nav-text-cta"
                        className="btn-primary !py-2 !min-h-0 text-xs sm:text-sm !px-3 sm:!px-4"
                    >
                        <MessageSquare className="w-4 h-4" /> <span className="hidden sm:inline">{t("cta_text_me")}</span><span className="sm:hidden">{t("cta_text_me")}</span>
                    </a>
                </div>
            </div>
        </header>
    );
}
